import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Temporary enum to replace missing EnumDeviceSensorsUiType
const EnumDeviceSensorsUiType = {
    Temp: 'temp',
    Rpm: 'rpm',
    Ph: 'ph',
};
const RadialDashboard = ({ device, liveSensorValues, }) => {
    const getSensorStyle = (type, value) => {
        switch (type) {
            case 'temp':
            case EnumDeviceSensorsUiType.Temp:
                return {
                    bg: 'from-red-50 to-orange-50',
                    border: 'border-red-300',
                    text: 'text-red-700',
                    icon: '🌡️',
                    statusColor: value !== null && value > 25 ? 'bg-red-500' : 'bg-green-500',
                };
            case 'rpm':
            case EnumDeviceSensorsUiType.Rpm:
                return {
                    bg: 'from-blue-50 to-indigo-50',
                    border: 'border-blue-300',
                    text: 'text-blue-700',
                    icon: '⚡',
                    statusColor: value !== null && value > 1000 ? 'bg-yellow-500' : 'bg-green-500',
                };
            case 'ph':
            case EnumDeviceSensorsUiType.Ph:
                return {
                    bg: 'from-green-50 to-emerald-50',
                    border: 'border-green-300',
                    text: 'text-green-700',
                    icon: '💧',
                    statusColor: value !== null && (value < 6.5 || value > 8.5)
                        ? 'bg-yellow-500'
                        : 'bg-green-500',
                };
            default:
                return {
                    bg: 'from-gray-50 to-slate-50',
                    border: 'border-gray-300',
                    text: 'text-gray-700',
                    icon: '📊',
                    statusColor: 'bg-gray-500',
                };
        }
    };
    const formatSensorValue = (value, type) => {
        if (value === null || value === undefined || typeof value === 'undefined')
            return 'N/A';
        if (typeof value !== 'number' || isNaN(value) || !isFinite(value))
            return 'N/A';
        switch (type) {
            case 'temp':
            case EnumDeviceSensorsUiType.Temp:
                return `${value.toFixed(1)}°C`;
            case 'rpm':
            case EnumDeviceSensorsUiType.Rpm:
                return `${value.toFixed(1)} Hz`;
            case 'ph':
            case EnumDeviceSensorsUiType.Ph:
                return `${value.toFixed(1)} pH`;
            default:
                return value.toFixed(1);
        }
    };
    const sensors = device.sensorsUI || [];
    const centerX = 50;
    const centerY = 50;
    const radius = 35;
    return (_jsxs("div", { className: "bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg border border-gray-200 p-6", children: [_jsxs("div", { className: "text-center mb-6", children: [_jsx("h2", { className: "text-2xl font-bold text-gray-900 mb-2", children: device.deviceLabel || device.deviceName || 'Radial Dashboard' }), _jsx("p", { className: "text-gray-600", children: "Circular sensor visualization" })] }), _jsxs("div", { className: "relative w-full h-96 mb-6", children: [_jsx("div", { className: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2", children: _jsx("div", { className: "w-24 h-24 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-xl", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-2xl", children: "\uD83C\uDFAF" }), _jsx("div", { className: "text-xs", children: "HUB" })] }) }) }), _jsxs("svg", { className: "absolute inset-0 w-full h-full pointer-events-none", children: [sensors.map((sensor, index) => {
                                if (!sensor)
                                    return null;
                                const angle = (index / sensors.length) * 2 * Math.PI;
                                const x = centerX + radius * Math.cos(angle);
                                const y = centerY + radius * Math.sin(angle);
                                return (_jsx("line", { x1: `${centerX}%`, y1: `${centerY}%`, x2: `${x}%`, y2: `${y}%`, stroke: "url(#gradient)", strokeWidth: "2", strokeDasharray: "5,5", opacity: "0.3" }, `line-${index}`));
                            }), _jsx("defs", { children: _jsxs("linearGradient", { id: "gradient", x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [_jsx("stop", { offset: "0%", stopColor: "#3B82F6" }), _jsx("stop", { offset: "100%", stopColor: "#8B5CF6" })] }) })] }), sensors.map((sensor, index) => {
                        if (!sensor)
                            return null;
                        const value = liveSensorValues[sensor.sensorName];
                        const formattedValue = formatSensorValue(value, sensor.type);
                        const styles = getSensorStyle(sensor.type, value);
                        const isAlert = styles.statusColor !== 'bg-green-500';
                        const angle = (index / sensors.length) * 2 * Math.PI;
                        const x = centerX + radius * Math.cos(angle);
                        const y = centerY + radius * Math.sin(angle);
                        return (_jsx("div", { className: `absolute transform -translate-x-1/2 -translate-y-1/2 group ${isAlert ? 'animate-pulse' : ''}`, style: { left: `${x}%`, top: `${y}%` }, children: _jsxs("div", { className: `
                bg-gradient-to-br ${styles.bg}
                border-2 ${styles.border}
                rounded-xl p-4 min-w-[120px] shadow-lg hover:shadow-xl
                transition-all duration-300 hover:scale-110 cursor-pointer
              `, children: [_jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-2xl mb-2", children: styles.icon }), _jsx("div", { className: `text-xs font-medium ${styles.text} mb-1`, children: sensor.label }), _jsx("div", { className: `text-lg font-bold ${styles.text} mb-2`, children: formattedValue }), _jsx("div", { className: `w-2 h-2 rounded-full mx-auto ${styles.statusColor} animate-pulse` })] }), _jsx("div", { className: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10", children: _jsxs("div", { className: "bg-gray-900 text-white text-xs rounded-lg p-2 whitespace-nowrap shadow-xl", children: [_jsx("div", { className: "font-semibold", children: sensor.label }), _jsxs("div", { children: ["Type: ", sensor.type] }), _jsxs("div", { children: ["Status: ", isAlert ? '⚠️ Alert' : '✅ Normal'] }), _jsx("div", { className: "absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900" })] }) })] }) }, `sensor-${index}`));
                    })] }), _jsxs("div", { className: "flex flex-wrap justify-center gap-4 text-sm", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx("div", { className: "w-3 h-3 bg-green-500 rounded-full" }), _jsx("span", { children: "Normal" })] }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx("div", { className: "w-3 h-3 bg-yellow-500 rounded-full" }), _jsx("span", { children: "Warning" })] }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx("div", { className: "w-3 h-3 bg-red-500 rounded-full" }), _jsx("span", { children: "Critical" })] })] })] }));
};
export default RadialDashboard;
